import { Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { AGGridCellRenderParams } from "~/pages/Compliance/ComplianceTable/types";

interface Props {
  params: AGGridCellRenderParams;
}

export const EnableComplianceCellRenderer = ({ params }: Props) => {
  const isEnabled = params.value === "Enabled";
  const isDisabled = params.value === "Disabled";
  const color = isEnabled ? Colors.Success600 : Colors.Neutral600;
  return (
    <Flex alignItems="center" gap={4} css={{ height: "100%" }}>
      {(isEnabled || isDisabled) && (
        <Icon
          type={isEnabled ? "check" : "xmark"}
          color={color}
          data-testid="case-status-icon"
          data-cy="case-status-icon"
        />
      )}
      <Text data-testid="profile-name-label" variant="strong-md" css={{ color }}>
        {params.value}
      </Text>
    </Flex>
  );
};
